import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PART_COSTS_NOT_SAVED_CHANGES_FEATURE_KEY,
  PartCostsNotSavedChangesEntity,
  partCostsNotSavedChangesAdapter,
} from './part-costs-not-saved-changes.reducer';
import { EntityState } from '@ngrx/entity';

const { selectEntities } = partCostsNotSavedChangesAdapter.getSelectors();

const getPartCostsNotSavedChangesFeatureState = createFeatureSelector<EntityState<PartCostsNotSavedChangesEntity>>(
  PART_COSTS_NOT_SAVED_CHANGES_FEATURE_KEY
);
// eslint-disable-next-line
export const getPartCostsNotSavedChangesEntities = () =>
  createSelector(getPartCostsNotSavedChangesFeatureState, (state: EntityState<PartCostsNotSavedChangesEntity>) =>
    selectEntities(state)
  );
